const SUPPORTED_TYPES = ['critical', 'warning', 'info'];

const TYPE_PRIORITY = {
  critical: 3,
  warning: 2,
  info: 1,
};

function normalizeType(notificationType) {
  if (!notificationType) return '';
  return String(notificationType).toLowerCase();
}

export function isSupportedBannerType(notificationType) {
  const t = normalizeType(notificationType);
  return SUPPORTED_TYPES.includes(t);
}

export function selectPortalBannerNotification(notifications) {
  if (!Array.isArray(notifications) || notifications.length === 0) return null;

  const supported = notifications
    .filter(n => n && isSupportedBannerType(n.notificationType) && n.id && n.text)
    .map(n => ({
      ...n,
      notificationType: normalizeType(n.notificationType),
      startTime: typeof n.startTime === 'number' ? n.startTime : Number(n.startTime) || 0,
    }));

  if (supported.length === 0) return null;

  supported.sort((a, b) => {
    const pa = TYPE_PRIORITY[a.notificationType] || 0;
    const pb = TYPE_PRIORITY[b.notificationType] || 0;
    if (pa !== pb) return pb - pa;

    const ta = a.startTime || 0;
    const tb = b.startTime || 0;
    if (ta !== tb) return tb - ta;

    const ida = String(a.id || '');
    const idb = String(b.id || '');
    return ida.localeCompare(idb);
  });

  return supported[0] || null;
}

export function getBannerDismissKey(notificationId) {
  return `banner_dismissed_${notificationId}`;
}
